import { camelCase, isArray, isPlainObject, snakeCase } from 'lodash';

export const transformOutgoingData = (data) => transformData(data, snakeCase);
export const transformIncomingData = (data) => transformData(data, camelCase);

const transformData = (data, transformer) => {
  if (isPlainObject(data)) {
    const newObj = {};

    for (const key in data) {
      newObj[transformer(key)] = transformData(data[key], transformer);
    }

    return newObj;
  } else if (isArray(data)) {
    return data.map((item) => transformData(item, transformer));
  }

  return data;
};
